export const UPLOAD_PROFILE_IMAGE = 'UPLOAD_PROFILE_IMAGE'
export const UPLOAD_PROFILE_IMAGE_SUCCESS = 'UPLOAD_PROFILE_IMAGE_SUCCESS'
export const UPLOAD_CLIENT_IMAGE = 'UPLOAD_CLIENT_IMAGE'
export const UPLOAD_CLIENT_IMAGE_SUCCESS = 'UPLOAD_CLIENT_IMAGE_SUCCESS'
export const UPLOAD_PITCH_FILE = 'UPLOAD_PITCH_FILE'
export const UPLOAD_PITCH_FILE_SUCCESS = 'UPLOAD_PITCH_FILE_SUCCESS'
export const UPLOAD_FILE = 'UPLOAD_FILE'
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS'
